export default __webpack_public_path__ + "static/1380-c161d9220d3a6605f9c8037d22683fe9.gif";